<template>
  <div class="dashboard-editor-container">
    <el-row :gutter="32">
      <el-col :sm="24" :lg="18">
        <el-row>
          <el-col class="hidden-xs-only">
            <div class="wj_mail_top">
              <el-col :xs="24" :sm="2">
                <div class="header_avater">
                  <el-image :src="header_url"></el-image>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12">
                <div class="header_content">
                  <div class="header_title">{{ getMorning() }}{{ current_user.realname }}，祝你开心每一天！</div>
                  <div v-if="current_user.prev_login_time" class="header_desc">上次登录时间【{{ current_user.prev_login_time }}】</div>
                </div>
              </el-col>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :sm="24" :lg="6">
        <el-row>
          <div class="wj_mail_right">
            <div class="tel_left"><i class="el-icon-phone-outline"></i></div>
            <div class="tel_content">
              <div class="tel_title">在线客服</div>
              <div>0471-4953016</div>
            </div>
          </div>
        </el-row>
      </el-col>
    </el-row>

    <el-row :gutter="24">
      <el-col :span="12">
        <el-form ref="queryForm" inline :model="userQuery" style="text-align: center;" @submit.native.prevent>
          <el-form-item prop="time">
            <el-date-picker
              v-model="userQuery.time"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              @change="SearchUserData"
            >
            </el-date-picker>
          </el-form-item>
        <!-- <el-form-item prop="address">
          <el-select v-model="userQuery.user_type" clearable placeholder="请选择用户类型" @change="SearchUserData">
            <el-option label="普通用户" value="1"></el-option>
            <el-option label="会员" value="2"></el-option>
          </el-select>
        </el-form-item> -->
        </el-form>
        <div id="user" style="width: 100%;height: 300px;"></div>
      </el-col>
      <el-col :span="12">
        <el-form ref="queryForm" inline :model="reservationQuery" style="text-align: center;" @submit.native.prevent>
          <el-form-item prop="time">
            <el-date-picker
              v-model="reservationQuery.time"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="reservationpickerOptions"
              @change="SearchReservationData"
            >
            </el-date-picker>
          </el-form-item>
        <!-- <el-form-item prop="reservation_type">
          <el-select v-model="reservationQuery.reservation_type" clearable placeholder="请选择预约类型" @change="SearchReservationData">
            <el-option label="场地" value="1"></el-option>
            <el-option label="教练" value="2"></el-option>
          </el-select>
        </el-form-item> -->
        </el-form>
        <div id="reservation" style="width: 100%;height: 300px;"></div>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="24">
        <el-form ref="queryForm" inline :model="orderQuery" style="text-align: center;" @submit.native.prevent>
          <el-form-item prop="time">
            <el-date-picker
              v-model="orderQuery.time"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="orderpickerOptions"
              @change="SearchOrderData"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="order_type">
            <el-select v-model="orderQuery.order_type" clearable placeholder="请选择支付方式" @change="SearchOrderData">
              <el-option label="微信支付" value="1"></el-option>
              <el-option label="余额支付" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div id="order" style="width: 100%;height: 300px;"></div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
// import 'element-ui/lib/theme-chalk/display.css'
// import PanelGroup from './components/PanelGroup'

import { mapGetters } from 'vuex'
import * as echarts from 'echarts'
import api from '@/api/index'
export default {
  name: 'DashboardAdmin',
  components: {
    // PanelGroup
  },
  filters: {

  },
  data() {
    return {
      header_url: '/header.png',
      qrcode_url: '/qrcode-wechat.png',
      // 用户数据
      userQuery: {
        time: '',
        user_type: ''
      },
      userText: '',
      userTextname: '',
      usercolor: '',
      userXdata: [],
      userSeries: [],
      pickerRange: 3600 * 1000 * 24 * 30, // 可选择日期范围（31天）
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime()
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (time.getTime() > (this.pickerMinDate + this.pickerRange)) || (time.getTime() < (this.pickerMinDate - this.pickerRange))
          }
          return false
        }
      },
      // 预约数据
      reservationQuery: {
        time: '',
        reservation_type: ''
      },
      reservationText: '',
      reservationTextname: '',
      reservationcolor: '',
      reservationXdata: [],
      reservationSeries: [],
      reservationpickerRange: 3600 * 1000 * 24 * 30, // 可选择日期范围（31天）
      reservationpickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime()
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (time.getTime() > (this.pickerMinDate + this.reservationpickerRange)) || (time.getTime() < (this.pickerMinDate - this.pickerRange))
          }
          return false
        }
      },
      // 数据
      orderQuery: {
        time: '',
        order_type: ''
      },
      orderText: '',
      orderTextname: '',
      ordercolor: '',
      orderXdata: [],
      orderSeries: [],
      orderpickerRange: 3600 * 1000 * 24 * 30, // 可选择日期范围（31天）
      orderpickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime()
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (time.getTime() > (this.pickerMinDate + this.orderpickerRange)) || (time.getTime() < (this.pickerMinDate - this.pickerRange))
          }
          return false
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted() {
    this.userChats()
    this.orderChats()
    this.reservationChats()
  },
  created() {
    this.SearchUserData()
    this.SearchReservationData()
    this.SearchOrderData()
  },
  methods: {
    // 获取用户趋势
    SearchUserData() {
      api.getUserChats(this.userQuery).then(res => {
        console.log(res)
        this.userXdata = res.data.time
        this.userSeries = res.data.count
        this.userText = res.data.text
        this.userTextname = res.data.textname
        this.usercolor = res.data.color
        console.log(this.userSeries)
        this.userChats()
      })
    },
    // 获取预约趋势
    SearchReservationData() {
      api.getReservationChats(this.reservationQuery).then(res => {
        console.log(res)
        this.reservationXdata = res.data.time
        this.reservationTextname = res.data.textname
        this.reservationSeries = res.data.count
        this.reservationText = res.data.text
        this.reservationcolor = res.data.color
        console.log(this.reservationSeries)
        this.reservationChats()
      })
    },
    // 获取订单趋势
    SearchOrderData() {
      api.getOrderChats(this.orderQuery).then(res => {
        console.log(res)
        this.orderXdata = res.data.time
        this.orderTextname = res.data.textname
        this.orderSeries = res.data.count
        this.orderText = res.data.text
        this.ordercolor = res.data.color
        console.log(this.orderSeries)
        this.orderChats()
      })
    },
    // 用户趋势
    userChats() {
      var userText = this.userText
      var userTextname = this.userTextname
      var usercolor = this.usercolor
      var userXdata = this.userXdata
      var seriesData = this.userSeries
      var chartDom4 = document.getElementById('user')
      var myChart4 = echarts.init(chartDom4)
      var option = {
        title: {
          text: userText,
          left: 'center'
        },
        tooltip: {},
        legend: {
          data: userTextname,
          // 将图例放在底部中央
          top: 'auto',
          bottom: 0,
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: userXdata
        },
        yAxis: {},
        series: [
          {
            color: usercolor[0],
            name: userTextname[0],
            type: 'bar',
            data: seriesData[0]
          },
          {
            color: usercolor[1],
            name: userTextname[1],
            type: 'bar',
            data: seriesData[1]
          }
        ]
      }
      option && myChart4.setOption(option)
    },
    // 预约趋势
    reservationChats() {
      var reservationText = this.reservationText
      var reservationTextname = this.reservationTextname
      var reservationcolor = this.reservationcolor
      var reservationXdata = this.reservationXdata
      var reservationseriesData = this.reservationSeries
      var chartDom4 = document.getElementById('reservation')
      var myChart4 = echarts.init(chartDom4)
      var option = {
        title: {
          text: reservationText,
          left: 'center'
        },
        tooltip: {},
        legend: {
          data: reservationTextname,
          // 将图例放在底部中央
          top: 'auto',
          bottom: 0,
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: reservationXdata
        },
        yAxis: {},
        series: [
          {
            color: reservationcolor[0],
            name: reservationTextname[0],
            type: 'bar',
            data: reservationseriesData[0]
          },
          {
            color: reservationcolor[1],
            name: reservationTextname[1],
            type: 'bar',
            data: reservationseriesData[1]
          }
        ]
      }
      option && myChart4.setOption(option)
    },
    // 订单趋势
    orderChats() {
      var orderText = this.orderText
      var orderTextname = this.orderTextname
      var ordercolor = this.ordercolor
      var orderXdata = this.orderXdata
      var orderseriesData = this.orderSeries
      var chartDom4 = document.getElementById('order')
      var myChart4 = echarts.init(chartDom4)
      var option = {
        title: {
          text: orderText,
          left: 'center'
        },
        tooltip: {},
        legend: {
          data: orderTextname,
          // 将图例放在底部中央
          top: 'auto',
          bottom: 0,
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: orderXdata
        },
        yAxis: {},
        series: [
          {
            color: ordercolor[0],
            name: orderTextname[0],
            type: 'bar',
            data: orderseriesData[0]
          },
          {
            color: ordercolor[1],
            name: orderTextname[1],
            type: 'bar',
            data: orderseriesData[1]
          },
          {
            color: ordercolor[2],
            name: orderTextname[2],
            type: 'bar',
            data: orderseriesData[2]
          },
          {
            color: ordercolor[3],
            name: orderTextname[3],
            type: 'bar',
            data: orderseriesData[3]
          },
          {
            color: ordercolor[4],
            name: orderTextname[4],
            type: 'bar',
            data: orderseriesData[4]
          }
        ]
      }
      option && myChart4.setOption(option)
    },

    // 获取时间段
    getMorning() {
      let str = ''
      const now = new Date()
      const hour = now.getHours()
      if (hour < 6) {
        str = '凌晨好！'
      } else if (hour < 9) {
        str = '早上好！'
      } else if (hour < 12) {
        str = '上午好！'
      } else if (hour < 14) {
        str = '中午好！'
      } else if (hour < 17) {
        str = '下午好！'
      } else if (hour < 19) {
        str = '傍晚好！'
      } else if (hour < 22) {
        str = '晚上好！'
      } else {
        str = '夜里好！'
      }
      return str
    }
  }
}

</script>

<style lang="scss">
.wj_mail_top {
  width: 100%;
  min-height: 100px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,0.1);
  margin-bottom: 16px;
  padding: 5px 10px;

  .header_avater{
    width: 75px;
    height: 75px;
    float: left;
    margin-left: 5px;
    margin-top: 7px;
  }
  .header_content{
    width: 100%;
    float: left;
    margin-top: 10px;
    margin-left: 20px
  }
  .header_content div{
    margin-bottom: 12px;
    display: block;
    line-height: 30px;
  }
  .header_content_left{
    float: right;
  }
  .header_content_right{
    width: 95px;
    float: right;
    span{
      display: inline-block;
      width: 73px;
      background: #409EFF;
      height: 73px;
      color: #ffffff;
      font-size: 18px;
      line-height: 26px;
      text-align: center;
      padding: 10px;
      border-radius: 3px;
      cursor: pointer;
    }
  }
  .header_title{
    font-weight: 600;
    font-size: 20px;
    line-height: 34px;
    color: #909399;
  }
  .header_desc {
    line-height: 22px;
    color: rgba(0, 0, 0, .45);
    font-size: 14px;
  }
}
.wj_mail_right {
  width: 100%;
  min-height: 100px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,0.1);
  margin-bottom: 32px;
  padding: 5px 10px;
  color: #909399;

  .news-heading{
    font-size: 20px;
    line-height: 30px;
    font-weight: 100;
    padding: 10px 0px;
    border-bottom: 1px solid #dde9ed;

    i {
      padding: 0 10px;
    }
  }
  .news-list{
    padding-left: 20px;
    padding-top: 8px;
  }
  .news-list li{
    color: #5b9bd1;
    font-size: 16px;
    line-height: 28px;
    a{
      color: #909399;
      font-size: 15px;
    }
    a:hover{
      color: #409EFF;
    }
  }
  .tel_left{
    width: 75px;
    height: 75px;
    float: left;
    margin-left: 10px;
    margin-top: 15px;

    i {
      font-size: 60px;
    }
  }
  .tel_content{
    float: left;
    display: block;
    font-size: 16px;
    line-height: 30px;
    padding: 13px 10px;

    .tel_title{
      font-size: 20px;
      font-weight: 600;
      line-height: 34px;
    }
  }
  .qrcode{
    width: 180px;
    height: 180px;
    margin: 15px auto;
  }
  .qrcode_title{
    text-align: center;
    margin-bottom: 15px;

    span{
      color: #409EFF;
    }
  }
}
.box-card{
  margin: 10px 0px;
}
.dashboard-editor-container {
  padding: 32px;
  position: relative;

  .chart-title{
    background: #fff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 10px;
    padding: 15px 20px;
    font-weight: 400;
    font-size: 14px;
    span::before{
      content: "";
      display: inline-block;
      width: 3px;
      height: 12px;
      position: relative;
      top: 1px;
      background: #6190E8;
      margin-right: 10px;
    }
  }
  .chart-wrapper {
    background: #fff;
    border-radius: 5px;
    min-height: 416px;
    padding: 16px 16px 0;
    margin-bottom: 32px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1)
  }
}

</style>
